import getCountryFromUrl, { getLanguageFromUrl } from "utils/getCountryFromUrl";

export const getStytchTemplateCountry = () => {
  const country = getCountryFromUrl();
  const language = getLanguageFromUrl()?.raw?.toUpperCase();
  let index: string;
  if (country === "CA" && language === "FR") {
    index = "CA_FR";
  } else if (country === "FR" && language === "FR") {
    index = "FR_FR";
  } else {
    index = country;
  }
  return index;
};
